(function() {
  'use strict';

  angular.module('app').factory('NewsService', NewsService);

  NewsService.$inject = ['$rootScope', 'API', 'NotifyService'];

  function NewsService($rootScope, API, NotifyService) {
    var service = {};

    $rootScope.$on('user-logout', function() {
      $rootScope.NEWS = null;
    });

    /**
     * Get list of all or filtered News.
     * WARNING! $rootScope.NEWS not full list because can be filtered
     */
    service.All = function(params, callback) {
      API.get('/news?{0}'.format(paramsToUrlQueryEncodeURIComponent(params)), function(success, data) {
        if (success) {
          $rootScope.NEWS = data.data;
        }
        callback(success, data);
      });
    };

    /**
     * Get News info
     */
    service.Get = function(id, callback) {
      API.get('/news/' + id, function(success, data) {
        if (success) {
          updateItemInList($rootScope.NEWS, data);
        }
        callback(success, data);
      });
    };

    /**
     * Create new News
     */
    service.Create = function(post_data, callback) {
      API.post('/news', post_data, function(success, data) {
        if (success) {
          NotifyService.Success(data.message, false);
        }
        callback(success, data);
      });
    };

    /**
     * Change News info
     */
    service.Change = function(id, post_data, callback) {
      API.patch('/news/' + id, post_data, function(success, data) {
        if (success) {
          updateItemInList($rootScope.NEWS, data);
          NotifyService.Success(data.message, false);
        }
        callback(success, data);
      });
    };

    /**
     * Upload photo
     */
    service.UploadPhoto = function(id, data, callback) {
      API.postImage('/news/' + id + '/photo', data, function(success, response) {
        callback(success, response);
      });
    };

    return service;
  }

})();
